import { get } from '@/services/apiClient';

export interface ChatSnapshot {
  role: 'user' | 'assistant' | 'tool' | 'result' | 'error';
  content: string;
  tool?: string;
  ts: number;
}

interface ChatHistoryResponse {
  messages: ChatSnapshot[];
  count: number;
}

export async function getChatHistory(agentId: string, limit = 100): Promise<ChatSnapshot[]> {
  const resp = await get<ChatHistoryResponse>(`/api/v1/chat/history/${agentId}?limit=${limit}`);
  return resp.messages ?? [];
}
